import React, { useState } from 'react';
import './VirtualCard.css';

const VirtualCard = () => {
    const [showCardNumber, setShowCardNumber] = useState(false);
    const [showCVV, setShowCVV] = useState(false);

    // Different card data from the screenshot
    const cardData = {
        cardNumber: '4789 3421 8765 2109',
        cvv: '842',
        expiryDate: '08/2028',
        currency: 'USD',
        cardType: 'Prepaid Card',
        balance: '2,580.50',
        status: 'Active',
        issueDate: '2024-12-05 14:35:22',
        firstName: 'Alexandra',
        lastName: 'Chen',
        phoneCode: '+1',
        phoneNumber: '3104567892',
        email: 'alexandra.chen@protonmail.com',
        countryCode: 'CA',
        country: 'Canada',
        state: 'ON',
        city: 'Toronto',
        street: 'Queen Street West',
        billingAddress: '1456 Harbourfront Avenue',
        postalCode: 'M5V 2W8',
        notes: 'Premium VIP Card'
    };

    const maskCardNumber = (number) => {
        if (showCardNumber) return number;
        const parts = number.split(' ');
        return `${parts[0]} •••• •••• ${parts[3]}`;
    };

    const maskCVV = (cvv) => {
        return showCVV ? cvv : '•••';
    };

    return (
        <div className="virtual-card-container">
            <div className="virtual-card-header">
                <h2>Virtual Card Details</h2>
                <p className="card-subtitle">Your Digital Payment Card</p>
            </div>

            {/* Card Visual Display */}
            <div className="card-visual">
                <div className="card-background">
                    <div className="card-chip"></div>
                    <div className="card-number-display">
                        {maskCardNumber(cardData.cardNumber)}
                    </div>
                    <div className="card-holder-info">
                        <div className="card-field">
                            <span className="card-field-label">CARD HOLDER</span>
                            <span className="card-field-value">{cardData.firstName} {cardData.lastName}</span>
                        </div>
                        <div className="card-field">
                            <span className="card-field-label">EXPIRES</span>
                            <span className="card-field-value">{cardData.expiryDate}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Card Information Section */}
            <div className="card-info-section">
                <h3 className="section-title">Card Information</h3>
                <div className="info-grid">
                    <div className="info-item">
                        <label className="info-label">Card Number</label>
                        <div className="info-value-wrapper">
                            <span className="info-value primary">{maskCardNumber(cardData.cardNumber)}</span>
                            <button
                                className="toggle-visibility-btn"
                                onClick={() => setShowCardNumber(!showCardNumber)}
                                title={showCardNumber ? "Hide Card Number" : "Show Card Number"}
                            >
                                {showCardNumber ? (
                                    <svg viewBox="0 0 24 24" width="18" height="18">
                                        <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
                                    </svg>
                                ) : (
                                    <svg viewBox="0 0 24 24" width="18" height="18">
                                        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>

                    <div className="info-item">
                        <label className="info-label">CVV</label>
                        <div className="info-value-wrapper">
                            <span className="info-value security-code">{maskCVV(cardData.cvv)}</span>
                            <button
                                className="toggle-visibility-btn"
                                onClick={() => setShowCVV(!showCVV)}
                                title={showCVV ? "Hide CVV" : "Show CVV"}
                            >
                                {showCVV ? (
                                    <svg viewBox="0 0 24 24" width="18" height="18">
                                        <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
                                    </svg>
                                ) : (
                                    <svg viewBox="0 0 24 24" width="18" height="18">
                                        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Expiry Date</label>
                        <span className="info-value">{cardData.expiryDate}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Currency</label>
                        <span className="info-value currency">{cardData.currency}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Card Type</label>
                        <span className="info-value badge badge-type">{cardData.cardType}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Card Balance</label>
                        <span className="info-value balance">{cardData.currency} {cardData.balance}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Card Status</label>
                        <span className="info-value badge badge-active">{cardData.status}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Issue Date</label>
                        <span className="info-value date">{cardData.issueDate}</span>
                    </div>
                </div>
            </div>

            {/* Personal Information Section */}
            <div className="card-info-section">
                <h3 className="section-title">Cardholder Information</h3>
                <div className="info-grid">
                    <div className="info-item">
                        <label className="info-label">First Name</label>
                        <span className="info-value">{cardData.firstName}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Last Name</label>
                        <span className="info-value">{cardData.lastName}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Phone Code</label>
                        <span className="info-value">{cardData.phoneCode}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Phone Number</label>
                        <span className="info-value">{cardData.phoneNumber}</span>
                    </div>

                    <div className="info-item full-width">
                        <label className="info-label">Email</label>
                        <span className="info-value">{cardData.email}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Country Code</label>
                        <span className="info-value">{cardData.countryCode}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Country</label>
                        <span className="info-value">{cardData.country}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">State</label>
                        <span className="info-value">{cardData.state}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">City</label>
                        <span className="info-value">{cardData.city}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Street</label>
                        <span className="info-value">{cardData.street}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Billing Address</label>
                        <span className="info-value">{cardData.billingAddress}</span>
                    </div>

                    <div className="info-item">
                        <label className="info-label">Postal Code</label>
                        <span className="info-value">{cardData.postalCode}</span>
                    </div>

                    <div className="info-item full-width">
                        <label className="info-label">Notes</label>
                        <div className="notes-box">
                            {cardData.notes}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VirtualCard;